import { useState } from "react";
import circleGif from "../../asset/Home/circleGif.gif";
import waveform from "../../asset/Home/waveForm.svg";
import lines from "../../asset/Home/liveDemoLines.svg";
import redCircle from "../../asset/Home/demoRedCircle.svg";
import { useEffect, useRef } from "react";
import { useInView } from "framer-motion";

function LiveDemoForm() {
  const tags = [
    "Sales",
    "Healthcare",
    "Customer Service",
    "Lead Qualification",
    "Appointment",
    "Debt Collection",
  ];

  const sectionRef = useRef(null);

  const isInView = useInView(sectionRef, {
    once: true,
    amount: 0.4,
  });

  const [animationCompleted, setAnimationCompleted] = useState(false);

  useEffect(() => {
    if (!isInView || animationCompleted) return;

    let index = 0;

    const interval = setInterval(() => {
      setFormData((prev) => ({
        ...prev,
        useCase: tags[index],
      }));

      index++;

      if (index >= tags.length) {
        clearInterval(interval);

        setAnimationCompleted(true);
      }
    }, 1200);

    return () => clearInterval(interval);
  }, [isInView, animationCompleted]);

  const [formData, setFormData] = useState({
    useCase: "",
    name: "",
    phone: "",
  });
  const handleTagClick = (tag) => {
    setAnimationCompleted(true);

    setFormData((prev) => ({
      ...prev,
      useCase: tag,
    }));
  };
  return (
    <section
      id="live-demo"
      ref={sectionRef}
      className="
		py-12
		md:py-16
		lg:py-20

		px-4
		sm:px-6
	"
      style={{ zoom: "0.89" }}
    >
      <div
        className="
		relative
		overflow-hidden

		max-w-[1400px]
		mx-auto

		bg-[#373632]

		rounded-[24px]
		lg:rounded-[36px]

		p-5
		sm:p-6
		lg:p-10

		grid
		grid-cols-1
		xl:grid-cols-2

		gap-10
		lg:gap-12
	"
        style={{ zoom: "0.95" }}
      >
        {/* Left Decorative Lines */}

        <img
          src={lines}
          alt=""
          className="
		absolute
		left-0
		top-0

		w-[70px]

		opacity-40

		pointer-events-none
		select-none
	"
        />
        <img
          src={redCircle}
          alt=""
          className="
		absolute

		top-0
		right-0

		w-[180px]
		sm:w-[280px]
		md:w-[400px]
		lg:w-[550px]

		translate-x-[35%]
		-translate-y-[35%]

		pointer-events-none
		select-none

		z-[999]
	"
        />

        {/* LEFT */}

        <div className="relative z-10">
          <div
            className="
							inline-block
							bg-[#5A5754]
							text-white
							text-sm
							font-medium
							px-4
							py-2
							rounded-lg
						"
          >
            Live Demo
          </div>

          <h2
            className="
							mt-6
							text-white
							font-prompt
							font-bold
text-[28px]
sm:text-[34px]
lg:text-[37px]
							leading-tight
						"
          >
            Experience Our AI Customer Success Agent
          </h2>

          <div
            className="
		relative
		mt-10

		h-[220px]
sm:h-[260px]
lg:h-[300px]

		flex
		items-center
		justify-center
	"
          >
            <div
              className="
		w-[180px]
h-[180px]

sm:w-[230px]
sm:h-[230px]

lg:w-[280px]
lg:h-[280px]
		rounded-full
		overflow-hidden
		relative
		z-10
	"
            >
              <img
                src={circleGif}
                alt=""
                className="
			absolute
			top-1/2
			left-1/2

			w-[400px]
sm:w-[550px]
lg:w-[700px]

			-max-translate-x-1/2
		"
                style={{
                  transform: "translate(-50%,-50%) scale(2.5)",
                }}
              />
            </div>

            <img
              src={waveform}
              alt=""
              className="
			absolute
			w-[260px]
sm:w-[380px]
lg:w-[520px]

			z-20
		"
            />
          </div>
          <div
            className="
							mt-10

							flex
							flex-wrap
justify-center
lg:justify-start

gap-2
sm:gap-3
						"
          >
            {tags.map((tag) => (
              <button
                key={tag}
                onClick={() => handleTagClick(tag)}
                className={`
									px-3
sm:px-4

py-2

text-xs
sm:text-sm
										rounded-md
										
										font-medium
										transition-all

										${
                      formData.useCase === tag
                        ? "bg-[#E8604A] text-white"
                        : "bg-[#4C4845] text-white hover:bg-[#5A5551]"
                    }
									`}
              >
                {tag}
              </button>
            ))}
          </div>
        </div>
        <img
          src={lines}
          alt=""
          className="
		absolute

		right-0
		bottom-0

		w-[90px]

		rotate-180

		opacity-35

		pointer-events-none
		select-none
	"
        />

        {/* RIGHT */}

        <div
          className="
		relative
		z-20

		bg-[#373632]
		border
		border-[#46423F]

		rounded-[28px]

		p-5
sm:p-7
lg:p-10
	"
        >
          <h3
            className="
							text-white
							font-prompt
							font-bold
text-[22px]
sm:text-[26px]
lg:text-[30px]

max-w-full
lg:max-w-[500px]
							leading-tight
							
						"
          >
           Receive a live call from our AI Customer Success Agent and experience how it resolves customer queries, provides personalized support, and delivers human-like conversations 24/7.
          </h3>

          <div className="mt-10">
            <label
              className="
								text-[#F5AB4C]
								text-sm
								font-medium
							"
            >
              Use case
            </label>

            <input
              value={formData.useCase}
              onChange={(e) => {
                setAnimationCompleted(true);

                setFormData({
                  ...formData,
                  useCase: e.target.value,
                });
              }}
              className="
    w-full
    bg-transparent
    border-b
    border-[#585451]
    text-white
    text-base
    sm:text-lg
    lg:text-xl
    py-4
    outline-none
  "
            />
          </div>

          <div className="mt-6">
            <label
              className="
								text-[#F5AB4C]
								text-sm
								font-medium
							"
            >
              Name
            </label>

            <input
              value={formData.name}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  name: e.target.value,
                })
              }
              placeholder="John"
              className="
								w-full
								bg-transparent
								border-b
								border-[#585451]

								text-white
								text-base
sm:text-lg
lg:text-xl

								py-4
								outline-none
							"
            />
          </div>

          <div className="mt-6">
            <label
              className="
								text-[#F5AB4C]
								text-sm
								font-medium
							"
            >
              Phone Number
            </label>

            <input
              value={formData.phone}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  phone: e.target.value,
                })
              }
              placeholder="+91 82976-67897"
              className="
								w-full
								bg-transparent
								border-b
								border-[#585451]

								text-white
								text-base
sm:text-lg
lg:text-xl

								py-4
								outline-none
							"
            />
          </div>

          <button
            className="
							mt-12

							bg-[#E8604A]
							text-white

							font-semibold

							w-full
sm:w-auto

h-[50px]

px-10

							rounded-md

							hover:opacity-90
							transition-all
						"
          >
            Get My Demo Call
          </button>
        </div>
      </div>
    </section>
  );
}

export default LiveDemoForm;
